// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "--" + {"2905":"996be5f","3215":"b652aee","3288":"f4fe5ce","4176":"c04621f","4580":"7aa7e0d","7344":"5b30416","7828":"6ab494e"}[chunkId] + ".css";
};